export const translations = {
  en: {
    // Header
    phone: "Call",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    vk: "VKontakte",
    cart: "Cart",

    // Banner
    bannerTitle: "Welcome to HedraNewShop",
    bannerSubtitle: "Quality beverages with delivery",

    // Categories
    categoriesTitle: "Categories",
    beer: "Beer",
    wine: "Wine",
    spirits: "Spirits",
    rtd: "RTD",
    extra: "Extras",
    comingSoon: "Coming Soon",

    // Subcategories
    beerSubcategoriesTitle: "Beer - Choose Brand",
    wineSubcategoriesTitle: "Wine - Choose Type",
    spiritsSubcategoriesTitle: "Spirits - Choose Type",
    rtdSubcategoriesTitle: "RTD - Choose Brand",

    // Products
    productsTitle: "Products",
    alcohol: "Alcohol",
    addToCart: "Add to Cart",

    // Cart
    yourCart: "Your Cart",
    cartEmpty: "Your cart is empty",
    quantity: "Quantity",
    subtotal: "Subtotal",
    delivery: "Delivery",
    total: "Total",
    deliveryArea: "Delivery area",
    selectArea: "Select delivery area",
    hurghada: "Hurghada",
    alAhyaa: "Al Ahyaa",
    orderWhatsApp: "Order via WhatsApp",
    remove: "Remove",
    deliveryDependsOnLocation: "Delivery cost depends on your location",
    useMyLocation: "Use my location",
    locationProcessing: "Determining location...",
    locationSuccess: "Location saved for the order",
    locationError: "Unable to determine location",
    locationPermissionDenied: "Location access denied",
    locationUnavailable: "Location information unavailable",
    locationTimeout: "Location request timed out",
    locationUnsupported: "Geolocation is not supported in this browser",
    locationCoordinates: "Location",
    locationMapLink: "Map link",
    customRequestsTitle: "Dear valued customer",
    customRequestsMessage:
      "If you'd like to add something that wasn't in the catalog, just let us know!",
    installAppButton: "Install app",
    installAppMessage:
      "For a smoother experience, install HedraNewShop as an app on your device.",
    installIOSInstructions:
      "Tap the Share button at the bottom, then select 'Add to Home Screen'.",
    installMacOSInstructions:
      "Click the Share button in the address bar, then select 'Add to Dock'.",

    // WhatsApp Message
    newOrder: "New order from HedraNewShop",
    orderTotal: "Total",

    // Currency
    currency: "EGP",
  },
  ru: {
    // Header
    phone: "Позвонить",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    vk: "ВКонтакте",
    cart: "Корзина",

    // Banner
    bannerTitle: "Добро пожаловать в HedraNewShop",
    bannerSubtitle: "Качественные напитки с доставкой",

    // Categories
    categoriesTitle: "Категории",
    beer: "Пиво",
    wine: "Вино",
    spirits: "Крепкие напитки",
    rtd: "RTD",
    extra: "Дополнительно",
    comingSoon: "Скоро",

    // Subcategories
    beerSubcategoriesTitle: "Пиво - Выберите бренд",
    wineSubcategoriesTitle: "Вино - Выберите тип",
    spiritsSubcategoriesTitle: "Крепкие напитки - Выберите тип",
    rtdSubcategoriesTitle: "RTD - Выберите бренд",

    // Products
    productsTitle: "Товары",
    alcohol: "Алкоголь",
    addToCart: "В корзину",

    // Cart
    yourCart: "Ваша корзина",
    cartEmpty: "Ваша корзина пуста",
    quantity: "Количество",
    subtotal: "Сумма товаров",
    delivery: "Доставка",
    total: "Итого",
    deliveryArea: "Зона доставки",
    selectArea: "Выберите зону доставки",
    hurghada: "Хургада",
    alAhyaa: "Эль Ахьяа",
    orderWhatsApp: "Заказать через WhatsApp",
    remove: "Удалить",
    deliveryDependsOnLocation: "Стоимость доставки зависит от вашего местоположения",
    useMyLocation: "Моё местоположение",
    locationProcessing: "Определяем местоположение...",
    locationSuccess: "Местоположение добавлено к заказу",
    locationError: "Не удалось определить местоположение",
    locationPermissionDenied: "Доступ к геоданным запрещён",
    locationUnavailable: "Местоположение недоступно",
    locationTimeout: "Время ожидания местоположения истекло",
    locationUnsupported: "Геолокация не поддерживается в этом браузере",
    locationCoordinates: "Координаты",
    locationMapLink: "Ссылка на карту",
    customRequestsTitle: "Уважаемый клиент",
    customRequestsMessage:
      "Если вы хотите добавить что-то, чего не нашли в нашем каталоге, просто напишите нам!",
    installAppButton: "Установить приложение",
    installAppMessage:
      "Для более комфортной работы установите приложение HedraNewShop.",
    installIOSInstructions:
      "Нажмите кнопку «Поделиться» внизу, затем выберите «На экран «Домой»».",
    installMacOSInstructions:
      "Нажмите кнопку «Поделиться» в адресной строке, затем выберите «Добавить в Dock».",

    // WhatsApp Message
    newOrder: "Новый заказ из HedraNewShop",
    orderTotal: "Итого",

    // Currency
    currency: "EGP",
  },
};
